import React, { Component } from 'react'

import {
    Message,
    Section,
    css,
    Icon,
    Theme,
    Grid,
    GridCell,
} from '@bdfx/mergado-ui-kit'

class Maintenance extends Component<{}, {}> {
    render() {
        return (
            <StyledGrid>
                <GridCell />
                <Message
                    icon={<Icon type={'wrench'} color={Theme.steelblue} size={32} />}
                    closeable={false}
                    type={"info"}
                    text={<p>Právě probíhá údržba. Budeme brzy zpět...<br />The maintenance is currently in progress. We will be back soon...</p>}
                />
                <GridCell />
            </StyledGrid>
        )
    }
}

const StyledGrid = css(Grid)({
    marginTop: '60px',
    gridTemplateColumns: 'auto max-content auto',
    gridGap: '20px',
    padding: '40px',
    fontSize: '18px',
})

export default Maintenance